import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import ImagePlaceholder from './ImagePlaceholder';
import { useLanguage } from '../context/LanguageContext';

const Gallery = () => {
  const { t } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const galleryItems = [
    { type: 'image', url: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/1fd58949d881f87b59a9b4d87afb58a3.png', alt: t.gallery.alts[0], caption: t.gallery.captions?.frontExterior },
    { type: 'image', url: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/4a6ea99184e24cad8b73065a5304879b.png', alt: t.gallery.alts[1] },
    { type: 'image', url: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/a341dfba419fdceeeb28df0199c47155.png', alt: t.gallery.alts[2] },
    { type: 'image', url: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/75d75d5bcdcbdebc242e136eefb18dbe.png', alt: t.gallery.alts[3] },
    { type: 'image', url: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/c2da0c49fb562f2f3d86abaf5b52c786.png', alt: t.gallery.alts[4] },
    { type: 'image', url: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/c926c099811db65f3f8aa999fdbe5a21.png', alt: t.gallery.alts[5] },
    { type: 'image', url: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/584bd13dee4b82205c740e6b653e3785.png', alt: t.gallery.alts[6] },
    { type: 'image', url: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/0b8ef8635f21bd8ad88762f09aecc748.png', alt: t.gallery.alts[7] },
    { type: 'image', url: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/ec73c53a01da29aa638dd0d79f80dbff.png', alt: t.gallery.alts[8], caption: t.gallery.captions?.lakeView },
    { type: 'image', url: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvanBlZw==/873ba2c2bcf3318500e629e3ed7f7625.jpg', alt: t.gallery.alts[9] },
    { type: 'image', url: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/1034b4bd631646c59e473b22601bac1b.png', alt: t.gallery.alts[10] },
    { type: 'image', url: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/1da577f87b7d749eed8863bbb04a255b.png', alt: t.gallery.alts[11] },
    { type: 'image', url: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/22856906de6fd1ca70b4d6880157e420.png', alt: t.gallery.alts[12] },
    { type: 'image', url: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/5225213fd318172af975e2db9796b0a8.png', alt: t.gallery.alts[13] }
  ];

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setIsOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setIsOpen(false);
    document.body.style.overflow = 'auto';
  };

  const nextImage = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev === galleryItems.length - 1 ? 0 : prev + 1));
  };

  const prevImage = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev === 0 ? galleryItems.length - 1 : prev - 1));
  };

  useEffect(() => {
    const handleOpenGallery = (e) => {
      openLightbox(e.detail?.index || 0);
    };
    window.addEventListener('openGallery', handleOpenGallery);
    return () => window.removeEventListener('openGallery', handleOpenGallery);
  }, []);

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isOpen) return;
      if (e.key === 'ArrowRight') nextImage(e);
      if (e.key === 'ArrowLeft') prevImage(e);
      if (e.key === 'Escape') closeLightbox();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen]);

  return (
    <section id="gallery" className="section-padding bg-white">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">{t.gallery.title}</h2>
          <p className="text-lg text-slate-600">{t.gallery.subtitle}</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {galleryItems.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
              className={`cursor-pointer group ${index === 0 ? 'col-span-2 row-span-2' : ''}`}
              onClick={() => openLightbox(index)}
            >
              <div className="relative h-full w-full overflow-hidden rounded-xl bg-slate-100">
                {item.type === 'image' ? (
                  <img
                    src={item.url}
                    alt={item.alt}
                    loading="lazy"
                    className="w-full h-full object-cover min-h-[150px] transition-transform duration-500 group-hover:scale-105"
                  />
                ) : (
                  <ImagePlaceholder label={item.label} className="w-full h-full min-h-[150px] transition-transform duration-500 group-hover:scale-105" />
                )}
                <div className="absolute inset-0 bg-slate-900/0 group-hover:bg-slate-900/10 transition-colors duration-300 flex items-center justify-center">
                  <SafeIcon name="Maximize2" className="text-white opacity-0 group-hover:opacity-100 w-8 h-8 transition-opacity duration-300 drop-shadow-md" />
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[100] bg-slate-900/95 flex items-center justify-center p-4 backdrop-blur-sm"
            onClick={closeLightbox}
          >
            <button
              onClick={closeLightbox}
              className="absolute top-6 right-6 text-white/70 hover:text-white p-2 focus:outline-none focus:ring-2 focus:ring-white rounded-full transition-colors z-10"
              aria-label="Close gallery"
            >
              <SafeIcon name="X" className="w-8 h-8" />
            </button>

            <div className="relative w-full max-w-5xl aspect-[4/3] max-h-[85vh] flex items-center justify-center" onClick={(e) => e.stopPropagation()}>
              <button
                onClick={prevImage}
                className="absolute left-2 md:left-4 z-10 p-2 md:p-3 rounded-full bg-black/50 text-white hover:bg-black/70 focus:outline-none focus:ring-2 focus:ring-white transition-colors"
                aria-label="Previous image"
              >
                <SafeIcon name="ChevronLeft" className="w-6 h-6 md:w-8 md:h-8" />
              </button>

              <div className="w-full h-full bg-slate-800/50 rounded-lg overflow-hidden shadow-2xl flex items-center justify-center relative">
                {galleryItems[currentIndex].type === 'image' ? (
                  <>
                    <img
                      src={galleryItems[currentIndex].url}
                      alt={galleryItems[currentIndex].alt}
                      className="max-w-full max-h-full object-contain"
                    />
                    {(galleryItems[currentIndex].caption || galleryItems[currentIndex].alt) && (
                      <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent pt-16 pb-4 px-4 text-center">
                        <p className="text-white text-sm md:text-base font-medium drop-shadow-md">
                          {galleryItems[currentIndex].caption || galleryItems[currentIndex].alt}
                        </p>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="text-center text-slate-400">
                    <SafeIcon name="Image" className="w-20 h-20 mx-auto mb-4 opacity-50" />
                    <p className="text-2xl font-medium">{galleryItems[currentIndex].label}</p>
                    <p className="text-sm mt-2">{currentIndex + 1} {t.gallery.of} {galleryItems.length}</p>
                  </div>
                )}
              </div>

              <button
                onClick={nextImage}
                className="absolute right-2 md:right-4 z-10 p-2 md:p-3 rounded-full bg-black/50 text-white hover:bg-black/70 focus:outline-none focus:ring-2 focus:ring-white transition-colors"
                aria-label="Next image"
              >
                <SafeIcon name="ChevronRight" className="w-6 h-6 md:w-8 md:h-8" />
              </button>
            </div>

            <div className="absolute bottom-6 left-0 right-0 text-center text-white/70 text-sm font-medium">
              {currentIndex + 1} / {galleryItems.length}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default Gallery;